import * as types from "../actions/actionTypes";
export function topicSearch(state = [], action) {
  switch (action.type) {
    case types.LOAD_TOPICS_SUCCESS:
      return action.serviceResponse;
    default:
      return state;
  }
}

export function responseHasErrored(state = false, action) {
  switch (action.type) {
    case "RESPONSE_HAS_ERRORED":
      return action;
    default:
      return state;
  }
}

export function topicRender(state = [], action) {
  switch (action.type) {
    case types.RENDER_TOPIC_SUCCESS:
      return action.serviceResponse;
    default:
      return state;
  }
}

export const genusReducer = (state = [], action) => {
  switch (action.type) {
    case "GENUS_ACTION_SUCCESS":
      return { ...state, ...action.genusList };
    case "GENUS_ACTION_ERROR":
      return { ...state };
    default:
      return state;
  }
};

const setLoginDetailsInCookie = (userDetails) => {
  let date = new Date();
  let expireAfter = 60;
  date.setTime(date.getTime() + expireAfter * 60000);
  let loginCookie = `vetLogin=${JSON.stringify(
    userDetails
  )}; expires=${date.toUTCString()};  path=/`;
  window.document.cookie = loginCookie;
};

const checkLoginDetailsInCookie = () => {
  let cookie = window.document.cookie
    .split(";")
    .find((ck) => ck.split("=")[0].trim() === "vetLogin");
  if (cookie === undefined || cookie.trim() === "vetLogin=") {
    return { isLoggedIn: false };
  }
  let cookieval = JSON.parse(cookie.trim().split("=")[1]);
  return { isLoggedIn: true, ...cookieval };
};

const removeLoginDetailsFromCookie = () => {
  let date = new Date();
  window.document.cookie = `vetLogin=; expires=${date.toUTCString()}; path=/`;
};

export const loginReducer = (
  state = { isLoggedIn: false, isError: false, loginModalOpen: false },
  action
) => {
  switch (action.type) {
    case "LOGIN_SESSION_CHECK":
      return { ...state, ...checkLoginDetailsInCookie() };
    case "LOGIN_ACTION_SUCCESS": {
      setLoginDetailsInCookie(action.userDetails);
      return {
        ...state,
        ...action.userDetails,
        isLoggedIn: true,
        loginModalOpen: false,
      };
    }
    case "LOGIN_ACTION_ERROR":
      return { ...state, isError: true };
    case "LOGOUT_ACTION_SUCCESS": {
      removeLoginDetailsFromCookie();
      return { ...state, isLoggedIn: false };
    }
    case "LOGOUT_ACTION_ERROR": {
      removeLoginDetailsFromCookie();
      return { ...state, isLoggedIn: false };
    }
    case "LOGIN_MODAL_OPEN":
      return { ...state, loginModalOpen: true };
    case "LOGIN_MODAL_CLOSE":
      return { ...state, loginModalOpen: false };
    default:
      return state;
  }
};
